// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Hr1iq","selected":"styles_selected__OqPQm"};